module.exports = __webpack_public_path__ + "img/wifi_signal_2.388b7526.svg";